const initialState = {
    rating: 5,
    userDescription: ''
};
const submitAnOrderComment = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_RATING_STAR_ORDER_COMMENT':
            return {...state, rating: action.rating};
        case 'TYPE_INPUT_USER_DESCRIPTION_ORDER_COMMENT':
            return {...state, userDescription: action.userDescription};
        default:
            return state;
    }
};

export default submitAnOrderComment;